import factory from './api';

const api = factory({ apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3333' });

export default api;
